import { makeStyles, shorthands } from "@fluentui/react-components";
import * as React from "react";
import type { PromptDetailBaseProps } from "./PromptDetail.web.data";
import { PromptDetailTitle } from "./PromptDetailTitle.web";
import { PromptPreview } from "./PromptPreview/PromptPreview.web";

const useStyles = makeStyles({
  page: {
    display: "flex",
    width: "45.3125rem",
    flexDirection: "column",
    alignItems: "center",
    ...shorthands.padding("2.5rem", "6.8125rem", "2.5rem", "6.8125rem"),
    ...shorthands.gap("1.5rem"),
    "@media (max-width: 540px)": {
      width: "auto",
      height: "113.625rem",
      alignItems: "flex-start",
      alignSelf: "stretch",
      ...shorthands.gap("0.75rem"),
      ...shorthands.padding("0rem", "0rem", "0rem", "0rem"),
    },
  },
  pageContent: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",
    ...shorthands.gap("48px"),
    "@media (max-width: 540px)": {
      flexDirection: "column",
      alignSelf: "stretch",
      ...shorthands.gap("3rem"),
      ...shorthands.padding("0rem 12rem"),
    },
  },
});

export const PromptDetailDiv: React.FC<PromptDetailBaseProps> = ({
  prompt,
  morePrompts,
  isBookmarkEnabled,
  isPromptSavingEnabled,
  isPromptSharingEnabled,
  isPromptSharingViaEmailEnabled,
  isShowPromptAuthor,
  onBookmarkToggled,
  onShareClicked,
  onCopyClicked,
  onClicked,
  onDelete,
  onTryInAppBadgeAction,
}) => {
  const styles = useStyles();
  return (
    <div className={styles.page}>
      <PromptDetailTitle prompt={prompt} />
      <div className={styles.pageContent}>
        <PromptPreview
          prompt={prompt}
          morePrompts={morePrompts}
          onClick={onClicked}
          isBookmarked={prompt.UserActivity.Favorite.IsFavorite}
          isBookmarkEnabled={isBookmarkEnabled}
          isPromptSavingEnabled={isPromptSavingEnabled}
          isPromptSharingEnabled={isPromptSharingEnabled}
          isPromptSharingViaEmailEnabled={isPromptSharingViaEmailEnabled}
          onBookmarkToggled={onBookmarkToggled}
          onShareClicked={onShareClicked}
          onCopyClicked={onCopyClicked}
          onDelete={onDelete}
          onTryInAppBadgeAction={onTryInAppBadgeAction}
          isShowPromptAuthor={isShowPromptAuthor}
        />
      </div>
    </div>
  );
};
